"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleButton = exports.Text = exports.Root = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3)
}));
const Text = exports.Text = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  maxLines,
  isOverflowVisible
}) => ({
  display: '-webkit-box',
  WebkitLineClamp: maxLines,
  WebkitBoxOrient: 'vertical',
  width: 'auto',
  overflow: isOverflowVisible ? 'visible' : 'hidden'
}));
const ToggleButton = exports.ToggleButton = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  color: theme.palette.default.main,
  textDecoration: 'underline',
  '&:hover': {
    color: theme.palette.primary.main,
    cursor: 'pointer'
  }
}));
//# sourceMappingURL=styles.js.map